import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  AccessControlConfigDto,
  UpsertAccessControlConfigDto,
} from '../../../models/access-control/dto/access-control-config.dto';
import { GET_ACCESS_CONTROL_CONFIGS_QUERY_KEY } from './useGetAccessControlConfigs';

export const useUpsertAccessControlConfig = (
  organizationId: string,
  onSuccess?: (config: AccessControlConfigDto) => void,
) => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['upsertAccessControlConfig', organizationId],
    mutationFn: (body: UpsertAccessControlConfigDto) =>
      apiClient.fetchApi<AccessControlConfigDto, UpsertAccessControlConfigDto>({
        method: 'PUT',
        endpoint: `access-control/admin/config/${organizationId}`,
        body,
      }),
    onSuccess: (data) => {
      queryClient.invalidateQueries(GET_ACCESS_CONTROL_CONFIGS_QUERY_KEY(organizationId));
      onSuccess?.(data);
    },
  });
};
